/**************/
/*	RATING    */
/**************/

//onVoteClickCallback : callback al hacer click y antes de hacer la acción de votación

	/*


		myRate = new rateProObject(
		id,							//Id del elemento
		type,
		options: {
				
		{

			dataFields:{
				identifier:"noticia",
				score:"score",
				positive:"score.positive",
				negative:"score.negative"
			},
			

			redirectURL: "www.w3c.com",			//default: false
			clearOnSubmit: false				//default: false
			extraFields: { "elem": value, "elem2": value...},	//default: false
			ignoreOKDefaultActions: false,						//default: false
			ignoreKODefaultActions: false,						//default: false
			callbackOnSuccess: function(e) { myFunc1(e) }		//default: function(){} //Si se establece 'e', esté valdrá el 'data' que se reciba de la llamada AJAX
			callbackOnFail: function(e) { myFunc2(e) }			//default: function(){}	//Si se establece 'e', esté valdrá el 'data' que se reciba de la llamada AJAX
			callbackOnError: function() { myFunc3() }			//default: function(){} //llamada cuando existe un error ejecutar lanzar la llamada AJAX,
			sendAsFile: false									//default: false, establece un método de envío alternativo para remitir ficheros.
		} );

	*/


var rateProObject = function(id,type,options){
	this.id=id; 				//ID Referido a votar
	this.useIdInAttr=false		//Si se establece, usa como ID el valor del primer atributo que se encuentre	
	this.score=0; 				//Puntos a añadir
	this.elemFav=$("[data-proRate]");
	this.type="rate"; 			//rate: tipo estrellas de x a y. 
								//likeDislike: tipo +1 -1
								
	//CONTADORES
	this.contadores = {};
	this.contadores.likePositiveSelector=	"[data-ratePosVotes]";
	this.contadores.likeNegativeSelector=	"[data-rateNegVotes]";
	this.contadores.rateVotesSelector=		"[data-rateTotalVotes]";

	//ESTRELLAS DE VALORACION ACTUAL
	this.stars = {};
	this.stars.elemSelector = 	"[data-currentRating]";
	this.stars.starSelector = 	"[data-star]";
	this.stars.starsToShow	= 5;
	this.stars.maxRateValue	= 100;
	this.stars.minRateValue	= 0;
	this.stars.fullClass 	= "full";
	this.stars.halfClass 	= "half";	
	this.stars.emplyClass 	= "";	

	//ASOCIACIÒN DE CAMPOS PARA LOS SUBMITS
	this.dataFields = {};
	this.dataFields.identifier = 	"nombre";
	this.dataFields.score = 		"score";
	this.dataFields.positive = 		"score.positive";
	this.dataFields.negative = 		"score.negative";

	//COOKIES
	this.cookies = {};
	this.cookies.cookieName =		"";

	//AJAX CALLS
	this.actionURL="";

	//FORME OBJPARAMS
// 	this.ajaxObjParams=false;
	this.callbackOnFail=function(){}
	this.callbackOnSuccess=function(){}
	this.callbackOnError=function(){}
	this.extraFields={}
	
	if(typeof type!=false)	{this.type=type}
	if(typeof options!="undefined")	{
		if(typeof options.elem!="undefined"){ this.elemFav=options.elem}
		if(typeof options.useIdInAttr!="undefined"){ this.useIdInAttr=options.useIdInAttr}	
		if(typeof options.onVoteClickCallback!="undefined"){ this.onVoteClickCallback=options.onVoteClickCallback}
		if(typeof options.callbackOnSuccess!="undefined"){ this.callbackOnSuccess=options.callbackOnSuccess}
		if(typeof options.callbackOnFail!="undefined"){ this.callbackOnFail=options.callbackOnFail}
		if(typeof options.callbackOnError!="undefined"){ this.callbackOnError=options.callbackOnError}
		if(typeof options.extraFields!="undefined"){ this.extraFields=options.extraFields}
		
		if( typeof options.counters != "undefined") {
			if(typeof options.contadores.likePositiveSelector!="undefined")	{ this.contadores.likePositiveSelector=options.contadores.likePositiveSelector}
			if(typeof options.contadores.likeNegativeSelector!="undefined")	{ this.contadores.likeNegativeSelector=options.contadores.likeNegativeSelector}
			if(typeof options.contadores.rateVotesSelector!="undefined")	{ this.contadores.rateVotesSelector=options.contadores.rateVotesSelector}
		}
	
		if( typeof options.dataFields != "undefined") {
			if(typeof options.dataFields.identifier!="undefined")			{ this.dataFields.identifier=options.dataFields.identifier}
			if(typeof options.dataFields.score!="undefined")				{ this.dataFields.score=options.dataFields.score}
			if(typeof options.dataFields.positive!="undefined")				{ this.dataFields.positive=options.dataFields.positive}
			if(typeof options.dataFields.negative!="undefined")				{ this.dataFields.negative=options.dataFields.negative}
		}		

		if( typeof options.cookies != "undefined") {
			if(typeof options.cookies.cookieName!="undefined")			{ this.cookies.cookieName=options.cookies.cookieName}
		}
	
		if( typeof options.actionURL != "undefined" )		{ this.actionURL = options.actionURL }
		if( typeof options.ajaxObjParams != "undefined" )	{ this.ajaxObjParams = options.ajaxObjParams }
	}
	
	this.numVotesSelector = "[data-nVotes]"
	this.starsSelector= "[data-proRating] label";
	

	
	//Guardamos referencia del objeto en el selector
	// 	$(this.elemFav).data("parentObj",this)
	var parentObj=this;
	this.reflow()

}
rateProObject.prototype.setOption = function (optionObj){
  if(typeof optionObj.elemFav != "undefined"){ this.elemFav=optionObj.elemFav };
}

rateProObject.prototype.reflow = function (){
	var parentObj=this;
	
	switch (parentObj.type){
		case "rate":
			$(parentObj.elemFav).addClass('rate');
		break;
		case "likeDislike":
			$(parentObj.elemFav).addClass('likeDislike');
		break;
	}
	this.elemNumVotes=	$(this.elemFav).find(this.numVotesSelector);
	this.elemStars=		$(this.elemFav).find(this.starsSelector);

	$(parentObj.elemStars).slice(1).off("mousedown.rating").on("mousedown.rating",function(){
		var valueToConvertToPrevious=$(this).closest($(parentObj.elemFav)).data('value');
		$(this).closest($(parentObj.elemFav)).data('prevValue',	valueToConvertToPrevious)
	})
	$(parentObj.elemStars).slice(1).off('touchstart.rating').on('touchstart.rating',function(){
		if (typeof $(this).closest($(parentObj.elemFav)).data('value') != "undefined") {
			$(this).closest($(parentObj.elemFav)).data('value',0);
		}
		if($(this).find('input').prop('checked')==true){
			$(this).closest($(parentObj.elemFav)).data('prevValue',$(this).find('input').val())
		}
	})	
	$(parentObj.elemStars).slice(1).off("mouseup.rating").on("mouseup.rating",function(){
	
		$(this).closest($(parentObj.elemFav)).data('value',$(this).find('input').val())
	
		if($(this).closest($(parentObj.elemFav)).data('value')==$(this).closest($(parentObj.elemFav)).data('prevValue')){
			$(this).closest($(parentObj.elemFav)).find($(parentObj.elemStars)).eq(0).find("input").prop("checked",true)
			$(this).closest($(parentObj.elemFav)).data('prevValue',0)
			$(this).closest($(parentObj.elemFav)).data('value',0)
			$(this).closest($(parentObj.elemFav)).find($(parentObj.elemStars)).removeClass('is-active');
		}else{
			$(this).find('input').prop("checked",true)
			$(this).closest($(parentObj.elemFav)).data('value',$(this).find('input').val())

			var clickedIndex=$(this).index();
			var i=0;
			$(this).closest($(parentObj.elemFav)).find($(parentObj.elemStars)).removeClass('is-active');
			if(parentObj.type=="rate"){
					$(this).closest($(parentObj.elemFav)).find($(parentObj.elemStars)).each(function(){
					if(i<clickedIndex){
						$(this).addClass('is-active');
					}
					i++;
				})
			}
 			$(this).addClass('is-active');
		}
		
		parentObj.score=$(this).closest($(parentObj.elemFav)).data('value');

		//Si el ID es dinámico, extraemos el valor del primer attributo indicado que encuentre, que lo contenga
		if(parentObj.useIdInAttr){
			parentObj.id=$(this).closest("["+parentObj.useIdInAttr+"]").attr(parentObj.useIdInAttr);
		}
		if(parentObj.onVoteClickCallback){
			parentObj.onVoteClickCallback();
		}else{
			parentObj.sendFav(parentObj.id,$(this).closest($(parentObj.elemFav)),parentObj.score);
		}		
	})
}

rateProObject.prototype.sendFav = function (identifier,formElem,score){
		
	if(!$(formElem).is("form")){
		var form=$(formElem).find('form');	
	}else{
		var form=$(formElem);
	}
 	var parentObj=this;
 	
 	if(typeof identifier == "undefined"){ var identifier=parentObj.id}
 	if(typeof score == "undefined"){ var score=parentObj.score} 	
	
	//Ejecular objAJAX Externo
	var extraFields=parentObj.extraFields;
	extraFields[parentObj.dataFields.identifier]=identifier;
	extraFields[parentObj.dataFields.score]=score;
	myForm = new formeSubmit($(form),parentObj.actionURL,
	{
		extraFields: extraFields,
		callbackOnSuccess: function(e) { 
			setVotingCounters(e,form);
			parentObj.callbackOnSuccess(e);
		}			
	}); 	
	
	function setVotingCounters(e,formElem){

		if(parentObj.type=="rate"){
			if(typeof e.data.votos != "undefined"){
				$(formElem).find(parentObj.contadores.rateVotesSelector).text(e.data.votos);
				var starsSelector=$(formElem).find(parentObj.stars.elemSelector);
				var starElem=$(starsSelector).find(parentObj.stars.starSelector);
				var htmlElementType=$(starElem).eq(0).removeClass();
				var html = "";
				var score = e.data.score;
				var estrellasEnteras = Math.trunc( (score*parentObj.stars.starsToShow)/parentObj.stars.maxRateValue )
				var estrellasMedias = (score*parentObj.stars.starsToShow)%parentObj.stars.maxRateValue

				$(starElem).remove();
				for(i=1;i<=parentObj.stars.starsToShow;i++){
					
					var htmlElem = htmlElementType;
					$(htmlElem).removeClass();
					if(i<=estrellasEnteras){	
						$(htmlElem).addClass(parentObj.stars.fullClass)
						html = html + $(htmlElem).prop('outerHTML');
					}else if(i==estrellasEnteras+1 && estrellasMedias>=49){
						$(htmlElem).addClass(parentObj.stars.halfClass)
						html = html + $(htmlElem).prop('outerHTML');						
					}else{
						$(htmlElem).addClass(parentObj.stars.emptyClass)
						html = html + $(htmlElem).prop('outerHTML');							
					}										
				}
				
				
				$(starsSelector).prepend(html);
			}
		}else{
			if(typeof e.data.score != "undefined" && e.data.score.positive != "undefined" && e.data.score.negative != "undefined"){
				$(formElem).find(parentObj.contadores.likePositiveSelector).text(e.data.score.positive);
				$(formElem).find(parentObj.contadores.likeNegativeSelector).text(e.data.score.negative);
			}
		}
		if(getCookie(parentObj.cookies.cookieName)!=""){
			var cookie=getCookie(parentObj.cookies.cookieName);
			var cookieArray=cookie.split(",");
			var cookieFound=false;
			$(cookieArray).each(function(index,value){
				if(value.search(parentObj.id+"_") >= 0){
					cookieArray.splice(index,1);
					cookieFound=true;
				}
			})
			if(parentObj.score!=0){
				cookieArray.push(parentObj.id+"_"+parentObj.score)
			}
			cookieFound=false;
			setCookie(parentObj.cookies.cookieName,cookieArray.join(),30)

		}else{
			if(parentObj.score!=0){
				setCookie(parentObj.cookies.cookieName,parentObj.id+"_"+parentObj.score,30);
			}
		}		
	}		
}
